import Vue from 'vue'
import VueClazyLoad from 'vue-clazy-load'
import VueSilentbox from 'vue-silentbox'
import Meta from 'vue-meta'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'


Vue.config.productionTip = false

Vue.use(VueClazyLoad)
Vue.use(VueSilentbox)
Vue.use(Meta)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
